import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';
import styles from './NewCustomerButton.module.css';
import Dropdown from '../common/Dropdown/Dropdown';
import privateClient from '../../assets/images/privateClient.png';
import businessClient from '../../assets/images/businessClient.png';

function NewCustomerButton() {
  const { t } = useTranslation();

  const newClientOptions = (
    <>
      <NavLink to='/private' className={styles.dropdownOption}>
        <img src={privateClient} alt={t('dashboard.privateClientIcon')}
             className={styles.dropdownOptionIcon} />
        <span className={styles.dropdownOptionText}>{t('dashboard.privateClient')}</span>
      </NavLink>
      <NavLink to='/legal' className={styles.dropdownOption}>
        <img src={businessClient} alt={t('dashboard.businessClientIcon')}
             className={styles.dropdownOptionIcon} />
        <span className={styles.dropdownOptionText}>{t('dashboard.businessClient')}</span>
      </NavLink>
    </>
  );

  return (
    <div className={styles.newClientBtn}>
      <Dropdown title={t('dashboard.newClient')}>
        {newClientOptions}
      </Dropdown>
    </div>
  )
}

export default NewCustomerButton;
